import { AvailabilityBlock, ReleaseStrategy } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { DateTimeLocalizationInfo, DurationService, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { LocalizedDateFromUtc, LocalizedShortTimeFromUtc } from '@mews-commander/ui';
import { getDayCountFromDuration, getShortTimeStringFromDuration } from '../../availabilityBlockEntityForm/utils';

export const getBlockReleaseStrategyView = (block: AvailabilityBlock, localizationInfo: DateTimeLocalizationInfo) => {
    switch (block.releaseStrategy.discriminator) {
        case ReleaseStrategy.FixedReleaseUtc: {
            return {
                textKey: TextKey.ReleaseAt,
                value: (
                    <>
                        <span data-test-date>
                            <LocalizedDateFromUtc utcString={block.releaseStrategy.value} />
                        </span>
                        {UnicodeEntity.NoBreakSpace}
                        <span data-test-time>
                            <LocalizedShortTimeFromUtc utcString={block.releaseStrategy.value} />
                        </span>
                    </>
                ),
            };
        }
        case ReleaseStrategy.RollingReleaseOffset: {
            const duration = DurationService.parse(block.releaseStrategy.value);
            return {
                textKey: TextKey.DailyRelease,
                value: (
                    <LocalizedText
                        textKey={TextKey.DayPriorAt}
                        substitutes={{
                            count: getDayCountFromDuration(duration),
                            time: getShortTimeStringFromDuration(duration, localizationInfo),
                        }}
                    />
                ),
            };
        }
        default:
            return {
                textKey: TextKey.BlockReleaseStrategyDoNotRelease,
                value: <span>{UnicodeEntity.Dash}</span>,
            };
    }
};
